import { Action } from 'redux';

import { IDataSourceDetailInfo } from '../../../datasource/models/IDataSourceInfo';
import { CreateRemoteExtractRefresh } from '../AppActionTypes';

export interface CreateRemoteExtractRefreshAction extends Action {
  datasource: IDataSourceDetailInfo;
}

export function createRemoteExtractRefresh(datasource: IDataSourceDetailInfo): CreateRemoteExtractRefreshAction {
  return {
    type: CreateRemoteExtractRefresh,
    datasource,
  };
}
